import jquery from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * 追加で他の項目に対してエラーチェックをする
 */
export default class EFOcats_event_addCheck extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    // カナ自動入力
    this.$('body').on('blur', 'input[data-input]', event => {
      const element = event.currentTarget;
      const obj = jquery(element);

      if (obj.val() === '') {
        return;
      }

      if (obj.attr('data-input').indexOf('input') >= 0) {
        const inputIndex = obj.attr('data-input').replace('input', '');

        obj
          .parents('.cat-container')
          .find(`input[data-input="output${inputIndex}"]`)
          .each((index, elem) => {
            efocats.validations.check_error(jquery(elem), false);
          });
      }
    });
  }
}
